import { Router } from '@angular/router';
import { QuestionarioService } from './../../../../services/admin/questionario.service';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';

@Component({
  selector: 'app-questionario-create',
  templateUrl: './questionario-create.component.html',
  styleUrls: ['./questionario-create.component.css'],
})
export class QuestionarioCreateComponent implements OnInit {
  public questionarioForm = this.fb.group({
    nome: ['', [Validators.required, Validators.minLength(3)]],
    ativacao: ['', [Validators.required]],
    descricao: ['', [Validators.required]],
    qtd_respostas: ['', [Validators.required]],
  });

  public erro: any = null;

  constructor(
    private fb: FormBuilder,
    private questionarioService: QuestionarioService,
    private router: Router
  ) {}

  ngOnInit() {}

  public onSubmit(): void {
    const formData = new FormData();
    formData.append('nome', this.questionarioForm.get('nome').value);
    formData.append('ativacao', this.questionarioForm.get('ativacao').value);
    formData.append('descricao', this.questionarioForm.get('descricao').value);
    formData.append('qtd_respostas', this.questionarioForm.get('qtd_respostas').value);

    this.questionarioService.create(formData).subscribe(
      (res: any) => {
        this.router.navigate(['/admin/questionarios']);
        this.questionarioService.toastSuccess(
          'Cadastro de Questionário efetuado com sucesso !'
        );
      },
      (error: any) => {
        this.erro = error;
        this.handleError(this.erro);
        this.questionarioForm.reset();
      }
    );
  }

  public handleError(erro): void {
    if (erro.status === 400) {
      this.questionarioService.toastError(
        'Não pode haver 2 questionários ativos. Desative o outro para cadastrar um novo questionário ativo'
      );
    } else {
      this.questionarioService.toastError('Erro ao efetuar cadastro da Questionário. Tente novamente !');
    }
  }

  public cancel(): void {
    this.router.navigate(['/admin/questionarios']);
  }

  get nome() {
    return this.questionarioForm.get('nome');
  }

  get ativacao() {
    return this.questionarioForm.get('ativacao');
  }

  get descricao() {
    return this.questionarioForm.get('descricao');
  }

  get qtd_respostas() {
    return this.questionarioForm.get('qtd_respostas');
  }
}
